import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {MarketingFooter} from './MarketingFooter'

registerReactPartial('marketing-footer', {
  Component: MarketingFooter,
})
